/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowBendLeftUp(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M208,224a8.00039,8.00039,0,0,1-8,8A104.11791,104.11791,0,0,1,96,128V88H56a8.00065,8.00065,0,0,1-5.65723-13.65723l48-48a8.003,8.003,0,0,1,11.31446,0l48,48A8.00066,8.00066,0,0,1,152,88H112v40a88.09957,88.09957,0,0,0,88,88A8.00039,8.00039,0,0,1,208,224Z" />
    </Svg>
  );
}

export default ArrowBendLeftUp;
